import axios from "./axios";
import {
  //Accounts
  BaseLevel,
  Level1,
  Level2,
  Level3,
  addInventory,
  addRawMetarial,
  createAccountVoucher,
  createVoucher,
  getAcountSetting,
  getAllCustomerReports,
  getArrearAmount,
  getComplaints,
  getCreatedOrderArray,
  getCustomerAccount,
  getCustomerById,
  getCustomerReport,
  getCustomerTrayAccount,
  getCustomers,
  getDepartmentById,
  getDepartments,
  getHR,
  getHRById,
  getInventory,
  getInventoryByDate,
  getInvioceDoc,
  getMessage,
  getModification,
  getMonthlyDailyReports,
  getOrder,
  getOrderDetailPage,
  getOrderItems,
  getOrderQuantity,
  getOrderStatus,
  getOrderSub_TypeTotalPrice,
  getOrderTypesTotalPrice,
  getOrdersDate,
  getProductById,
  getProducts,
  getPurchaseOrderStatus,
  getPurchaseOrdersDate,
  getRawMetarial,
  getRawMetarialByDate,
  getRecipe,
  getSupplier,
  getTask,
  getTotalReturn,
  getTrayStore,
  getUserById,
  getUsers,
  getmodificationQuantity,
  //POST//
  postCreateDeliverOrder,
  postCreateOrder,
  postCreateProductionOrder,
  postMissingOrder,
  postNewCreateOrder,
  postNewOrderPayment,
  postOrderPurchase,
  postPayment,
  postPaymentUpdate,
  postProductionOrder,
  postProductionStatus,
  postSupplierBill,
  postTrayUpdate,
  saveComplaints,
  saveMessage,
  saveTask,
  specificVoucher,
  subtractInventory,
  subtractRawMetarial,
  updateAcountSetting,
  updateComplaints,
  updateTask,
  voucher,
  voucherByDate,
  voucherDelete,
  voucherIndex,
  voucherInrange,
  voucherUpdate
} from "./endPoints";

//  Get Accounts URL Methods

const getLevel1URL = (level1Code) => Level1.replace(":level1", level1Code);

const getLevel2URL = (level1Code, level2Code) =>
  Level2.replace(":level1/:level2", level1Code + "/" + level2Code);

const getLevel3URL = (level1Code, level2Code, level3Code) =>
  Level3.replace(
    ":level1/:level2/:level3",
    level1Code + "/" + level2Code + "/" + level3Code
  );

const getVoucherIndexURL = (month, type) =>
  voucherIndex.replace(":month/:type", month + "/" + type);

const getVoucherURL = (level1, level2, level3) =>
  voucher.replace(
    ":level1/:level2/:level3",
    level1 + "/" + level2 + "/" + level3
  );

const getVoucherCreateURL = (type) => createVoucher.replace(":type", type);
const getAccountVoucherCreateURL = (type) => createAccountVoucher.replace(":type", type);

const getSpecificVoucherURL = (month, type, number) =>
  specificVoucher.replace(
    ":month/:type/:number",
    month + "/" + type + "/" + number
  );

const getVoucherByDateURL = (level1, level2, level3, date) =>
  voucherByDate.replace(
    ":level1/:level2/:level3/:date",
    level1 + "/" + level2 + "/" + level3 + "/" + date
  );

const getVoucherInRangeURL = (level1, level2, level3, start, end) =>
  voucherInrange.replace(
    ":level1/:level2/:level3/:startDate/:endDate",
    level1 + "/" + level2 + "/" + level3 + "/" + start + "/" + end
  );

const getVoucherUpdateURL = (type, index) =>
  voucherUpdate.replace(":type/:index", type + "/" + index);

const getVoucherDeleteURL = (type, index) =>
  voucherDelete.replace(":type/:index", type + "/" + index);

//  ***********Get-EndPoint*********
// ****************************************

export const nbfUsers = async () => {
  let response = await axios.get(getUsers, {});
  let data = response.data;
  return data;
};

export const nbfUserByID = async (userId) => {
  let endpoint = getUserById.replace(":id", userId);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const nbfCustomers = async () => {
  let response = await axios.get(getCustomers, {});
  let data = response.data;
  return data;
};

export const nbfCustomerByID = async (customerId) => {
  let endpoint = getCustomerById.replace(":id", customerId);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};
export const nbfGetDepartments = async () => {
  let response = await axios.get(getDepartments, {});
  let data = response.data;
  return data;
};
export const  nbfGetDepartmentById = async (departmentId) => {
  let endpoint = getDepartmentById.replace(":id", departmentId);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
}
export const nbfHR = async () => {
  let response = await axios.get(getHR, {});
  let data = response.data;
  return data;
};

export const nbfHRByID = async (hrId) => {
  let endpoint = getHRById.replace(":id", hrId);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const nbfProductByID = async (productId) => {
  let endpoint = getProductById.replace(":id", productId);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const nbfProduct = async () => {
  let response = await axios.get(getProducts, {});
  let data = response.data;
  return data;
};

export const nbfCustomerAccount = async () => {
  let response = await axios.get(getCustomerAccount, {});
  let data = response.data;
  return data;
};

//customer tray account
export const nbfCustomerTrayAccount = async () => {
  let response = await axios.get(getCustomerTrayAccount, {});
  let data = response.data;
  return data;
};

export const nbfInventory = async () => {
  let response = await axios.get(getInventory, {});
  let data = response.data;
  return data;
};
export const nbfAddInventory = async (data) => {
  let response = await axios.post(addInventory, data);
  let res = response.data;
  return res;
};

export const nbfSubtractInventory = async (data) => {
  let response = await axios.post(subtractInventory, data);
  let res = response.data;
  console.log(res);
  return res;
};
export const nbfInventoryByDate = async (date) => {
  let endpoint = getInventoryByDate.replace(":date", date);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};
export const nbfArrearAmount = async (customerId) => {
  let endpoint = getArrearAmount.replace(":id", customerId);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const getDates = async () => {
  let response = await axios.get(getOrdersDate, {});
  let data = response.data;
  return data;
};

export const getOrders = async (date) => {
  let endpoint = getOrder.replace(":date", date);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const nbfgetOrderStatus = async (date) => {
  let endpoint = getOrderStatus.replace(":date", date);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export function getTotal(array) {
  let total = 0;
  array.map((item) => {
    total = total + item.quantity * item.rate;
    return total;
  });
}

export const nbfOrderItems = async (formattedDate, customerId) => {
  let endpoint = getOrderItems
    .replace(":date", formattedDate)
    .replace(":id", customerId);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const nbfModificationItems = async (formattedDate, customerId) => {
  let endpoint = getModification
    .replace(":date", formattedDate)
    .replace(":id", customerId);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const nbfInvoice = async (selectedDate, customerId) => {
  let endpoint = getInvioceDoc
    .replace(":date", selectedDate)
    .replace(":id", customerId);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const nbfOrderDetailPage = async (date, customerId) => {
  let endpoint = getOrderDetailPage
    .replace(":date", date)
    .replace(":id", customerId);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const nbfPriceTypeByDates = async (startDate, endDate) => {
  let endpoint = getOrderTypesTotalPrice
    .replace(":startDate", startDate)
    .replace(":endDate", endDate);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const nbfSub_TypePriceByDates = async (startDate, endDate, type) => {
  let endpoint = getOrderSub_TypeTotalPrice
    .replace(":startDate", startDate)
    .replace(":endDate", endDate)
    .replace(":type", type);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};
export const nbfOrderTotalQuantity = async (selectedDate, selectedCategory) => {
  let endpoint = getOrderQuantity
    .replace(":date", selectedDate)
    .replace(":type", selectedCategory);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const nbfModificationTotalQuantity = async (
  selectedDate,
  selectedCategory
) => {
  let endpoint = getmodificationQuantity
    .replace(":date", selectedDate)
    .replace(":type", selectedCategory);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};
export const nbfTotalReturn = async (selectedDate) => {
  let endpoint = getTotalReturn.replace(":date", selectedDate);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};
export const nbfCreatedOrderArray = async (date, customerId) => {
  let endpoint = getCreatedOrderArray
    .replace(":date", date)
    .replace(":id", customerId);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const nbfRecipe = async () => {
  let response = await axios.get(getRecipe, {});
  let data = response.data;
  return data;
};
export const nbfSupplier = async () => {
  let response = await axios.get(getSupplier, {});
  let data = response.data;
  return data;
};
export const nbfSupplierBill = async (supplierBill) => {
  let response = await axios.post(postSupplierBill, supplierBill);
  let data = response.data;
  return data;
}
export const nbfgetPurchaseOrderStatus = async (date) => {
  let endpoint = getPurchaseOrderStatus.replace(":date", date);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};

export const nbfgetPurchaseDates = async () => {
  let response = await axios.get(getPurchaseOrdersDate, {});
  let data = response.data;
  return data;
};

export const nbfAllCustomerReport = async () => {
  try {
    let response = await axios.get(getAllCustomerReports);
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};

export const nbfCustomerReport = async (id) => {
  try {
    let response = await axios.post(getCustomerReport, { id });
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};

export const nbfMonthlyDailyReport = async (id, day, month, date1, date2) => {
  try {
    console.log(id, day, month, date1, date2);
    let response = await axios.post(getMonthlyDailyReports, {
      id,
      day,
      month,
      date1,
      date2,
    });
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};

export const getAllComplaints = async () => {
  try {
    let response = await axios.get(getComplaints);
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};

export const getTasks = async () => {
  try {
    let response = await axios.get(getTask);
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};

export const getSpecificMessage = async (id) => {
  try {
    let response = await axios.get(getMessage.replace(":id", id));
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};

//  ***********Export-Post-EndPoint**************
//             ********************

export const nbfcreatOrder = async (orderItems, customerId, formattedDate) => {
  let response = await axios.post(postCreateOrder, {
    order: [...orderItems],
    customerId,
    formattedDate,
  });
  let data = response.data;
  return data;
};

export const nbfPrductionOrder = async (
  orderItems,
  status,
  customerId,
  name,
  formattedDate
) => {
  let response = await axios.post(postProductionOrder, {
    order: [...orderItems],
    status,
    customerId,
    user: name,
    formattedDate,
  });
  let data = response.data;
  return data;
};
export const nbfCreateNewOrder = async (
  newOrderArray,
  customerId,
  formattedDate
) => {
  let response = await axios.post(postNewCreateOrder, {
    order: [...newOrderArray],
    customerId,
    formattedDate,
  });
  let data = response.data;
  return data;
};
export const nbfMissingOrder = async (customerId, date, missingItem) => {
  let response = await axios.post(postMissingOrder, {
    customerId,
    date,
    missedItems: missingItem,
  });
  let data = response.data;
  return data;
};
export const nbfProductionStatus = async (selectedDate, customerId) => {
  let response = await axios.post(postProductionStatus, {
    date: selectedDate,
    id: customerId,
  });
  let data = response.data;
  return data;
};

export const nbfCreateProductionOrder = async (productionOrderDetails) => {
  let response = await axios.post(postCreateProductionOrder, {
    productionOrderDetails,
  });
  let data = response.data;
  return data;
};

export const creatDeleverOrder = async (customerInvoiceDetails, order) => {
  let response = await axios.post(postCreateDeliverOrder, {
    ...customerInvoiceDetails,
    order: [...order],
  });
  let data = response.data;
  return data;
};

export const nbfNewOrderPayment = async (
  customerInvoiceDetails,
  customerId
) => {
  let response = await axios.post(postNewOrderPayment, {
    ...customerInvoiceDetails,
    id: customerId,
  });
  let data = response.data;
  return data;
};

export const dailyPayment = async () => {
  let response = await axios.post(postPayment, {});
  let data = response.data;
  return data;
};
export const paymentUpdate = async (paymentDetails) => {
  let response = await axios.post(postPaymentUpdate, { ...paymentDetails });
  let data = response.data;
  return { ...data, status: response.status };
};

export const trayUpdate = async (trayDetails) => {
  let response = await axios.post(postTrayUpdate, { ...trayDetails });
  let data = response.data;
  return { ...data, status: response.status };
};

export const nbfTrayStore = async (id) => {
  let response = await axios.get(`${getTrayStore}/${id}`);
  let data = response.data;
  return data;
};

export const nbfPostOrderPurchase = async (todayDate, values) => {
  let response = await axios.post(postOrderPurchase, {
    todayDate,
    order: values,
  });
  let data = response.data;
  return data;
};

//  Accounts

export const getLevelsData = async () => {
  try {
    let response = await axios.get(BaseLevel);
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getLevel1Data = async (level1Code) => {
  try {
    let response = await axios.get(getLevel1URL(level1Code));
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getLevel2Data = async (level1Code, level2Code) => {
  try {
    let response = await axios.get(getLevel2URL(level1Code, level2Code));
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getLevel3Data = async (level1Code, level2Code, level3code) => {
  try {
    let response = await axios.get(
      getLevel3URL(level1Code, level2Code, level3code)
    );
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getSpecificVoucherData = async (month, type, number) => {
  try {
    let response = await axios.get(getSpecificVoucherURL(month, type, number));
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getVoucherData = async (level1, level2, level3) => {
  try {
    let response = await axios.get(getVoucherURL(level1, level2, level3));
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getVoucherDataByDate = async (lev1, lev2, lev3, date) => {
  try {
    let response = await axios.get(getVoucherByDateURL(lev1, lev2, lev3, date));
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getVoucherDataInRange = async (
  level1,
  level2,
  level3,
  start,
  end
) => {
  try {
    let response = await axios.get(
      getVoucherInRangeURL(level1, level2, level3, start, end)
    );
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getVoucherIndex = async (month, type) => {
  try {
    let response = await axios.get(getVoucherIndexURL(month, type));
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

// Create Endpoints

export const createLevelsData = async (Data) => {
  try {
    let response = await axios.post(BaseLevel, { data: Data });
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const createLevel1Data = async (level1Code, Level1Data) => {
  try {
    let response = await axios.post(getLevel1URL(level1Code), {
      data: Level1Data,
    });
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const createLevel2Data = async (level1Code, level2Code, Level2Data) => {
  try {
    let response = await axios.post(getLevel2URL(level1Code, level2Code), {
      data: Level2Data,
    });
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const createLevel3Data = async (
  level1Code,
  level2Code,
  level3code,
  Level3Data
) => {
  try {
    let response = await axios.post(
      getLevel3URL(level1Code, level2Code, level3code),
      { data: Level3Data }
    );
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const createAccountVoucherData = async (type, VoucherData) => {
  try {
    let response = await axios.post(getAccountVoucherCreateURL(type), {
      data: VoucherData,
    });
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const createVoucherData = async (type, VoucherData) => {
  try {
    let response = await axios.post(getVoucherCreateURL(type), {
      data: VoucherData,
    });
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const saveComplaint = async (complaint) => {
  try {
    let response = await axios.post(saveComplaints, {
      data: complaint,
    });
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};

export const saveNewTask = async (task) => {
  try {
    let response = await axios.post(saveTask, {
      data: task,
    });
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};

export const saveNewMessage = async (id, message) => {
  try {
    let response = await axios.post(saveMessage.replace(":id", id), {
      data: message,
    });
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};

// Update Endpoints

export const updateLevelsData = async (Data) => {
  try {
    let response = await axios.patch(BaseLevel, { data: Data });
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const updateLevel1Data = async (level1Code, Data) => {
  try {
    let response = await axios.patch(getLevel1URL(level1Code), { data: Data });
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const updateLevel2Data = async (level1Code, level2Code, Data) => {
  try {
    let response = await axios.patch(getLevel2URL(level1Code, level2Code), {
      data: Data,
    });
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const updateLevel3Data = async (
  level1Code,
  level2Code,
  level3Code,
  Data
) => {
  try {
    let response = await axios.patch(
      getLevel3URL(level1Code, level2Code, level3Code),
      { data: Data }
    );
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const updateVoucherData = async (type, voucherData, index) => {
  try {
    let response = await axios.patch(getVoucherUpdateURL(type, index), {
      data: voucherData,
    });
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const updateComplaint = async (complaint, id) => {
  try {
    let response = await axios.patch(updateComplaints.replace(":id", id), {
      data: complaint,
    });
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};

export const updateSpecificTask = async (updatedTask, id ) => {
  try {
    let response = await axios.patch(updateTask.replace(":id", id), {
      data: updatedTask,
    });
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};

// Delete Endpoints

export const deleteLevelsData = async () => {
  try {
    let response = await axios.delete(BaseLevel);
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteLevel1Data = async (level1Code) => {
  try {
    let response = await axios.delete(getLevel1URL(level1Code));
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteLevel2Data = async (level1Code, level2Code) => {
  try {
    let response = await axios.delete(getLevel2URL(level1Code, level2Code));
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteLevel3Data = async (level1Code, level2Code, level3Code) => {
  try {
    let response = await axios.delete(
      getLevel3URL(level1Code, level2Code, level3Code)
    );
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteVoucherData = async (type, voucherData, index) => {
  try {
    let response = await axios.delete(getVoucherDeleteURL(type, index), {
      data: voucherData,
    });
    let data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteComplaints = async (id) => {
  try {
    let response = await axios.delete(updateComplaints.replace(":id", id));
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};


export const deleteTask = async (id) => {
  try {
    let response = await axios.delete(updateTask.replace(":id", id));
    let data = response.data;
    return data;
  } catch (error) {
    throw new Error("Backend Error, Something went wrong");
  }
};

export const nbfAccountSetting = async (selectedPaymentCash,selectedPaymentBank) => {
  let response = await axios.post(updateAcountSetting,
  {PaymentCash:selectedPaymentCash, PaymentBank:selectedPaymentBank});
  let res = response.data;
  console.log(res)
  return res;
};
export const nbfgetAccountSetting = async () => {
  let response = await axios.get(  getAcountSetting,{});
  let data = response.data;
  return data;
};

//rawMetarial API
export const nbfAddRawMetarial = async (data) => {
  let response = await axios.post(addRawMetarial, data);
  let res = response.data;
  return res;
};
export const nbfRawMetarial = async () => {
  let response = await axios.get(getRawMetarial, {});
  let data = response.data;
  return data;
}
export const nbfRawMetarialByDate = async (date) => {
  let endpoint = getRawMetarialByDate.replace(":date", date);
  let response = await axios.get(endpoint);
  let data = response.data;
  return data;
};
export const nbfSubtractRawMetarial = async (data) => {
  let response = await axios.post(subtractRawMetarial, data);
  let res = response.data;
  console.log(res);
  return res;
};
  